import { useInfiniteQuery } from '@tanstack/react-query';

import { activityQueryKey } from './activityQueries';

import { AuditLog } from '@/models/AuditLog';
import { getActivity } from '@/services/api/activity';

const DEFAULT_PAGE_SIZE = 20;

export const useActivity = (propertyId: string, pageSize: number = DEFAULT_PAGE_SIZE) => {
  const {
    data,
    isLoading,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    error,
  } = useInfiniteQuery({
    queryKey: activityQueryKey(propertyId, pageSize),
    queryFn: ({ pageParam }) => getActivity(propertyId, pageSize, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    enabled: Boolean(propertyId),
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
  });

  // Flatten activities from all pages
  const activities: AuditLog[] = data?.pages.flatMap((page) => page.items) ?? [];

  return {
    activities,
    isLoading,
    isFetching,
    isFetchingNextPage,
    hasNextPage: hasNextPage ?? false,
    fetchNextPage,
    error,
  };
};
